/**
* @ngdoc service
* @name checkout.payment.service:NostromoSvc
* @description
* Alipay Logic
*/
(function() {
    'use strict';

    angular
    .module('itxApp.common')
    .service('NostromoSvc', NostromoSvc);

    NostromoSvc.$inject = [
        'ItxScreenSizeSvc',
        '$http'
    ];

    function NostromoSvc (
        ItxScreenSizeSvc,
        $http ) {
        var _this = this;

        function getDevice(){
            var device; 
            if (ItxScreenSizeSvc.is('md,lg')){
                 device = 12; //DESKTOP
            }
            else{
             device = 11; //MOBILE
            }
            return device;
        }
      
        function login(){
                doRequest (10, 0);   
        }
        function loginDone(){             
                doRequest(10, 1);
        }
        function register(){
            doRequest (20, 0);   
        }
        function registerDone(){             
                doRequest(20, 1);
        }
        function recoverPasswd(){
            doRequest (15, 0);   
        }
        function recoverPasswdDone(){  
                doRequest(15, 1);
        }
    
        function payment(paymentId,shippingId){
            if(canNotifyStartPayment()){
                doRequest(50, 0);
                notifyStartPaymentWithInfo(paymentId);
                doRequest(40, 1); //CHECKOUT DONE
            }
        }

        function canNotifyStartPayment(){
            var orderId = inditex.iUserJSON.shopCart.id;
            var initOrdersString = sessionStorage.getItem('init_ord_nost');
            var initOrders = [];
            if(initOrdersString){
                initOrders = initOrdersString.split(',');
            }
            if(initOrders && initOrders.indexOf(orderId.toString()) == -1){
                initOrders.push(orderId.toString());
                sessionStorage.setItem('init_ord_nost',initOrders.join(','));
                return true;
            }
            else{
                return false;
            }
        }

        function paymentDone(){
            var order = inditex.iXOrderOrderSummaryJSON;
            if(!order){
                doRequest(50, 1);
            }
            else if(order.id != -1){
                notifyEndPaymentWithInfo(order);
            }
        }

        function notifyStartPaymentWithInfo(paymentId){
            var complexPaymentId = "" + 50 + paymentId;
            doRequest(complexPaymentId, 0);
        }

        function notifyEndPaymentWithInfo(order){
            var ordersString = sessionStorage.getItem('ord_nost');
            var orders = [];
            if(ordersString){
                orders = ordersString.split(',');
            }
            if(orders && orders.indexOf(order.id.toString()) == -1){
                orders.push(order.id.toString());
                sessionStorage.setItem('ord_nost',orders.join(','));
                var payment = order.payment[0];
                doRequest(50, 1);
                if(payment){
                    var complexPaymentId = "" + 50 + payment.code;
                    doRequest(complexPaymentId, 1);
                }
            }
        }

        function checkout(){
            doRequest(40, 0); //CHECKOUT
            doRequest(30, 1); //CART DONE
        }
        function cart(){
            doRequest(30, 0);
        }

        
        function doRequest(event, status){
            console.log('NOSTROMO LEGACY - ', event, status);
            if( window.location.hostname === 'www.massimodutti.com' || 
                window.location.hostname === 'www.massimodutti.cn'){
               
                $http.get('https://nostropix.com/nostropix.php/'+ inditex.iStoreId+'/'+event+'/'+getDevice()+'/'+status).then(function(){
                    
                });
            }
            
        }

        var service =  {
            login: login,
            loginDone: loginDone,
            payment: payment,
            paymentDone: paymentDone,
            checkout:checkout,
            cart:cart,
            register:register,
            registerDone:registerDone,
            recoverPasswd:recoverPasswd,
            recoverPasswdDone:recoverPasswdDone
    
        };

        return service;

     
    }

})();